import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { BoundingBox, Position } from '@rio-cloud/rio-uikit/components/map/utils/mapTypes';

const name = 'sidebarMap';

type SidebarMapState = {
    showSidebar: boolean;
    showAllTableEventMarkers: boolean;
    zoomToSelectedEvent: boolean;
    visibleTableEventIds: string[];
    zoomLevel?: number;
    center?: Position;
    boundingBox?: BoundingBox;
};

const initialState: SidebarMapState = {
    showSidebar: true,
    showAllTableEventMarkers: true,
    zoomToSelectedEvent: true,
    visibleTableEventIds: [],
    zoomLevel: undefined,
    center: undefined,
    boundingBox: undefined,
};

const { reducer, actions } = createSlice({
    name,
    initialState,
    reducers: {
        setShowSidebarMap: (state: SidebarMapState, action: PayloadAction<boolean>): void => {
            state.showSidebar = action.payload;
        },
        setShowAllTableEventMarkers: (state: SidebarMapState, action: PayloadAction<boolean>): void => {
            state.showAllTableEventMarkers = action.payload;
        },
        setZoomToSelectedEvent: (state: SidebarMapState, action: PayloadAction<boolean>): void => {
            state.zoomToSelectedEvent = action.payload;
        },
        setVisibleTableEventIds: (state: SidebarMapState, action: PayloadAction<string[]>): void => {
            state.visibleTableEventIds = action.payload;
        },
        setBoundingBox: (state: SidebarMapState, action: PayloadAction<BoundingBox | undefined>): void => {
            state.boundingBox = action.payload;
        },
        setMapView: (state: SidebarMapState, action: PayloadAction<{ center: Position; zoomLevel: number }>): void => {
            state.center = action.payload.center;
            state.zoomLevel = action.payload.zoomLevel;
        },
    },
});

export const sidebarMapActions = actions;
export const sidebarMapReducer = reducer;
